// Soft breathing tone: pitch and volume rise on the in-breath and fall on the out-breath.
export const createBreathTone = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  const ctx = new Ctx();
  const master = ctx.createGain();
  master.gain.value = 0;
  const filter = ctx.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 900;
  filter.connect(master).connect(ctx.destination);

  const oscs = [0, 7, -5].map((detune, i) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = i === 0 ? "sine" : "triangle";
    o.frequency.value = i === 2 ? 98 : 196;
    o.detune.value = detune;
    g.gain.value = i === 0 ? 0.6 : 0.2;
    o.connect(g).connect(filter);
    o.start();
    return o;
  });

  return {
    ctx,
    unlock: () => ctx.resume(),
    isRunning: () => ctx.state === "running",
    breathe(inhale, seconds) {
      const t = ctx.currentTime;
      const [lo, hi] = inhale ? [196, 294] : [294, 196];
      oscs.forEach((o, i) => {
        const mult = i === 2 ? 0.5 : 1;
        o.frequency.cancelScheduledValues(t);
        o.frequency.setValueAtTime(lo * mult, t);
        o.frequency.exponentialRampToValueAtTime(hi * mult, t + seconds);
      });
      master.gain.cancelScheduledValues(t);
      master.gain.setValueAtTime(master.gain.value, t);
      if (inhale) {
        master.gain.linearRampToValueAtTime(0.14, t + seconds * 0.85);
      } else {
        master.gain.linearRampToValueAtTime(0.1, t + seconds * 0.2);
        master.gain.linearRampToValueAtTime(0.015, t + seconds);
      }
    },
    fadeOut(seconds = 1.2) {
      const t = ctx.currentTime;
      master.gain.cancelScheduledValues(t);
      master.gain.setValueAtTime(master.gain.value, t);
      master.gain.linearRampToValueAtTime(0, t + seconds);
    },
    close() {
      setTimeout(() => ctx.close().catch(() => {}), 1500);
    },
  };
};
